export default __webpack_public_path__ + "static/media/partnerTop.076b3aea.svg";